import { useAtomValue, useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback, useState } from 'react';

import { useScrollToTop } from '~/hooks/use-scroll-to-top';
import { patientDetailDialogState } from '~/state/partials/patient_detail_dialog/atoms';
import { TabType } from '~/state/partials/patient_detail_dialog/types';
import { newPatientDrawerState } from '~/state/patient/atoms';

import { useCreateDirectVisitor } from '../use-create-direct-visitor';

export const useCreateOrOpenDirectVisitor = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [boxRef, scrollToTop] = useScrollToTop<HTMLDivElement>();
  const { create: createDirectVisitor } = useCreateDirectVisitor();
  const drawerState = useAtomValue(newPatientDrawerState);
  const resetDrawerState = useResetAtom(newPatientDrawerState);
  const setPatientDetailDialogState = useSetAtom(patientDetailDialogState);

  const createOrVisit = useCallback(
    async (value: string) => {
      setIsCreating(true);
      setError(null);

      try {
        if (value === 'new') {
          if (drawerState.inputValue) {
            await createDirectVisitor(drawerState.inputValue);
          }
        } else {
          setPatientDetailDialogState((_state) => ({
            ..._state,
            isOpen: true,
            type: 'message' as TabType,
            patientId: value,
          }));
        }
        resetDrawerState();
      } catch (_error) {
        scrollToTop();
        setError(_error?.message || 'エラーが発生しました');
      }
      setIsCreating(false);
    },
    [
      createDirectVisitor,
      drawerState.inputValue,
      setPatientDetailDialogState,
      resetDrawerState,
      scrollToTop,
    ],
  );

  return {
    creating: isCreating,
    error,
    boxRef,
    createOrVisit,
  };
};
